import React from 'react'
import { useRecoilState } from 'recoil'
import { GestureResponderEvent } from 'react-native'
import { UpdatePassword, UpdatePasswordParams } from '@/domain/usecases'
import { useAuth, useErrorHandler, useNotify, useTheme } from '@/presentation/hooks'
import { Box, Button, ModalBase, Text, TextInput } from '@/presentation/components'
import { UpdateSettingsStateProps, isOpenUpdatePasswordState, updateSettingsState } from './atom'
import { styles } from './styles'

type UpdatePasswordProps = {
  updatePassword: UpdatePassword
}

export const UpdatePasswordC: React.FC<UpdatePasswordProps> = ({ updatePassword }) => {
  const theme = useTheme()
  const notify = useNotify()
  const { getClient } = useAuth()
  const handleError = useErrorHandler()
  const [state, setState] = useRecoilState(updateSettingsState)
  const [isOpen, setOpen] = useRecoilState(isOpenUpdatePasswordState)

  const client = getClient()
  const isSamePassword = state.novaSenha &&
    state.confirmacaoSenha &&
    state.novaSenha === state.confirmacaoSenha

  const handleUpdatePassword = (event: GestureResponderEvent): void => {
    event.preventDefault()
    setState(currentState => ({ ...currentState, isLoading: true }))

    const updatePasswordParams: UpdatePasswordParams = {
      cliente: client.codCliente,
      senhaAtual: state.senhaAtual,
      novaSenha: state.novaSenha,
      confirmacaoSenha: state.confirmacaoSenha
    }

    updatePassword
      .update(updatePasswordParams)
      .then(() => notify.show('Senha alterada, a nova senha foi gravada com sucesso'))
      .catch(handleError)
      .finally(() => {
        handleClose()
        setState(currentState => ({ ...currentState, isLoading: false }))
      })
  }

  const handleChangeInput = (name: keyof UpdateSettingsStateProps, value: string): void => {
    setState(currentValues => ({ ...currentValues, [name]: value }))
  }

  const handleClose = (): void => {
    setOpen(false)
    handleReset()
  }

  const handleReset = (): void => {
    setState(currentValues => ({
      ...currentValues,
      senhaAtual: '',
      novaSenha: '',
      confirmacaoSenha: ''
    }))
  }

  return (
    <ModalBase visible={isOpen} onClose={handleClose}>
      <Box style={styles.container}>
        <Text variant="subtitle1">Alterar senha</Text>

        <TextInput
          label="Senha Atual"
          onChangeText={text => handleChangeInput('senhaAtual', text)}
          value={state.senhaAtual}
          secureTextEntry
          maxLength={30}
        />
        <TextInput
          label="Nova Senha"
          secureTextEntry
          onChangeText={text => handleChangeInput('novaSenha', text)}
          value={state.novaSenha}
          maxLength={30}
        />
        <TextInput
          label="Confirmar Nova Senha"
          secureTextEntry
          onChangeText={text => handleChangeInput('confirmacaoSenha', text)}
          value={state.confirmacaoSenha}
          maxLength={30}
        />

        <Box style={styles.buttonArea}>
          <Button
            color={theme.colors.shadow}
            tintColor={theme.colors.white}
            variant="text"
            title="CANCELAR"
            onPress={handleClose}
            disabled={state.isLoading}
            />
          <Button
            title="GRAVAR"
            onPress={handleUpdatePassword}
            tintColor={theme.colors.white}
            color={theme.colors.success}
            disabled={state.isLoading || !isSamePassword}
          />
        </Box>
      </Box>
    </ModalBase>
  )
}
